import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import OurPartnersSection from '@/v2/components/sections/common/our-partners-section'
import OurProcessSection from '@/v2/components/sections/common/our-process-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'

import {
  benefitsSectionContent,
  helperSectionContent,
  heroSectionContent,
  ourPartnersSectionContent,
  ourProcessSectionContent,
  promotionalBannerSectionContent,
  reliableShipSectionContent,
  serviceTipsSectionContent,
  whyChooseSectionContent
} from '@/v2/constants/pages/landing-pages/vacation-luggage-storage-and-shipping-page'

interface VacationLuggageStorageAndShippingPageProps {}

const VacationLuggageStorageAndShippingPage: React.FC<VacationLuggageStorageAndShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName='w-[324px] h-[218px] md-mn:w-[380px] md-mn:h-[286px] lg:!w-[448px] lg:!h-[313px] xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!h-[50px] w-[188px] h-[44px]'
      />
      <OurProcessSection {...ourProcessSectionContent} isBgDark btnClassName='!w-[283px]' />
      <PromotionalBannerSection
        card={reliableShipSectionContent}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`[&_article]:bg-transparent [&_article_p]:w-full md-mn:[&_article]:flex-row-reverse [&>div]:xl:max-w-[1100px]`}
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        className={`[&>div>div:nth-of-type(2)]:md-mn:grid-cols-3 [&_article]:text-center [&_article>div]:self-center`}
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`lg-mn:[&>div>div:last-of-type>div]:!flex-row-reverse [&>div>div:last-of-type>div]:flex-col`}
        sectionTitleClassName='xl-min:max-w-[700px]'
      />
      <BenefitsSection
        isBgDark
        {...benefitsSectionContent}
        className='[&_article]:bg-transparent [&_article]:border-none'
      />
      <OurProcessSection
        {...whyChooseSectionContent}
        className='[&_article]:bg-transparent lg-mn:[&>div>div:last-of-type]:flex-row-reverse lg-mn:[&>div>div:last-of-type>div:last-of-type]:grid lg-mn:[&>div>div:last-of-type>div:last-of-type]:grid-cols-2'
        imgClassName='xl-min:w-[460px] xl-min:h-[391px]'
        sectionTitleClassName='xl-min:!max-w-[650px] md-mn:max-w-[400px]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`[&_button]:w-[259px]`}
      />
      <OurPartnersSection isBgDark {...ourPartnersSectionContent} sectionTitleClassName='md-mn:[&_p]:max-w-[670px]' />
    </>
  )
}

export default VacationLuggageStorageAndShippingPage
